import { addDoc, collection } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { db } from "../firebase";

export const logAudit = async ({ familyId, action, entity, meta = {} }) => {
  if (!familyId) return;
  const auth = getAuth();
  const uid = auth.currentUser?.uid || "unknown";
  await addDoc(collection(db, "families", familyId, "audit"), {
    action,
    entity,
    meta,
    uid,
    createdAt: new Date()
  });
};
